import React from 'react';
import { countries } from '../utils/countries';

const CountrySelector = ({ activeCountry, onSelect }) => {
  return (
    <div className="country-selector">
      {/* Mobile Select */}
      <div className="mobile-country-select">
        <label htmlFor="country-dropdown" className="select-label">اختر الدولة:</label>
        <select
          id="country-dropdown"
          className="country-dropdown"
          value={activeCountry}
          onChange={(e) => onSelect(e.target.value)}
        >
          {countries.map((country) => (
            <option key={country.id} value={country.id}>
              {country.flag} {country.name}
            </option>
          ))}
        </select>
      </div>

      {/* Desktop Tabs */}
      <div className="country-tabs">
        {countries.map((country) => (
          <button
            key={country.id}
            className={`country-tab ${activeCountry === country.id ? 'active' : ''}`}
            onClick={() => onSelect(country.id)}
            id={`country-tab-${country.id}`}
          >
            <span className="country-flag">{country.flag}</span>
            <span className="country-name">{country.name}</span>
            <span className="country-currency">{country.currency}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CountrySelector;
